import { TrendBadge } from './trend-badge.component';
import { TrendBadgeArrows, TrendBadgeColors } from './trend-badge.types';
import { getTrendChange } from './utils';

export type TrendBadgeDeltaProps = {
  value: number;
  prevValue?: number;
  notAvailableLabel?: string;
};

export const TrendBadgeDelta = ({
  value,
  prevValue = 0,
  notAvailableLabel = 'N/A',
}: TrendBadgeDeltaProps) => {
  if ((!prevValue && value) || isNaN(value) || !isFinite(value)) {
    return <TrendBadge color='gray' label={notAvailableLabel} />;
  }
  if (!value && prevValue) {
    return <TrendBadge arrow='down' color='red' label='100%' />;
  }

  const change = getTrendChange(value, prevValue);
  let arrow: TrendBadgeArrows | undefined;
  let color: TrendBadgeColors = 'gray';

  if (change !== 0) {
    if (change > 0) {
      arrow = 'up';
      color = 'green';
    } else {
      arrow = 'down';
      color = 'red';
    }
  }

  return <TrendBadge arrow={arrow} color={color} label={`${Math.abs(change)}%`} />;
};
